import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../Components/Common/BreadCrumb';
import ProjectsOverview from '../Components/Dashboard/ProjectOverview';
import Widgets from '../Components/Dashboard/Widgets';

const DashboardProject = () => {
  document.title = "Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Dashboard" pageTitle="Dashboards" pageLink='/dashboard' />
          <Row className="project-wrapper">
            <Col xxl={8}>
              <Widgets />
              <ProjectsOverview />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardProject;